import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import Service from '../abstracts/Service.js';
import { getRaf, getCancelRaf } from '../utils/nextFrame.js';

var Raf = function (_Service) {
  _inherits(Raf, _Service);

  var _super = _createSuper(Raf);

  function Raf() {
    var _this;

    _classCallCheck(this, Raf);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "isTicking", false);

    _defineProperty(_assertThisInitialized(_this), "id", 0);

    _defineProperty(_assertThisInitialized(_this), "raf", getRaf());

    _defineProperty(_assertThisInitialized(_this), "cancelRaf", getCancelRaf());

    _this.loop = _this.loop.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Raf, [{
    key: "init",
    value: function init() {
      this.isTicking = true;
      this.loop();
      return this;
    }
  }, {
    key: "loop",
    value: function loop() {
      this.trigger(this.props);

      if (!this.isTicking) {
        return;
      }

      this.id = this.raf(this.loop);
    }
  }, {
    key: "kill",
    value: function kill() {
      this.cancelRaf(this.id);
      this.isTicking = false;
      return this;
    }
  }, {
    key: "props",
    get: function get() {
      return {
        time: window.performance.now()
      };
    }
  }]);

  return Raf;
}(Service);

var instance = null;
export default function useRaf() {
  if (!instance) {
    instance = new Raf();
  }

  var add = instance.add.bind(instance);
  var remove = instance.remove.bind(instance);
  var has = instance.has.bind(instance);

  function props() {
    return instance.props;
  }

  return {
    add: add,
    remove: remove,
    has: has,
    props: props
  };
}
//# sourceMappingURL=raf.js.map